(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $('.store-slider').slick({
      slidesToShow: 1,
  slidesToScroll: 1,
    dots: false,
  infinite: false,
    autoplay: false,
  autoplaySpeed: 3000,
    arrows: true,
  speed: 300,
     prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow')

  });
});

  } catch(e) { console.error(e); }
})();
})();
